import { useDataValue, useDataChange } from 'Simple/Data.js'
import { useClient } from 'Data/Api'
import query from './query-get-user-location-preferences.graphql.js'
import React, { useEffect } from 'react'
import View from './view.js'

export default function Logic(props) {
  let client = useClient()

  let change = useDataChange({
    context: 'tab',
    path: 'selected.filters',
    viewPath: props.viewPath,
  })

  let user_id = useDataValue({
    context: 'global',
    path: 'user.id',
    viewPath: props.viewPath,
  })

  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    async function loadPreferences() {
      let { data } = await client
        .query(query, { user_id, location_id })
        .toPromise()

      change(
        data.user_location_preferences_by_pk?.tasks_filter_presets?.filters ||
          {}
      )
    }

    loadPreferences()
  }, [])

  return <View {...props} viewPath={props.viewPath} />
}
